import React from 'react';

import { Logo, MCButton } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import SVGIcon, { BASE_ICONS, GENERAL_ICONS } from 'src/components/svg';
import FooterInfo from 'src/components/FooterInfo';

import { withRouter, lang, scssVariables, remCss } from 'src/helpers';

import BusinessWoman from 'src/assets/images/businesswoman.png';
import Doctor from 'src/assets/images/doctor.png';
import Hospital from 'src/assets/images/hospital.png';
import HomeImg from 'src/assets/images/welcome/left.png';
import MultipleImg from 'src/assets/images/welcome/multiple.png';
import GooglePlayImg from 'src/assets/images/google-play-logo.png';
import AppleImg from 'src/assets/images/apple-logo.png';
import model from './model';
import { Link } from 'react-router-dom';
import LangSelect from '../../components/LangSelect';

class WelcomeUser extends BaseComponent {
  refPages = [];
  refContainer = null;
  state = {
    position: 0,
    next: null
  };
  componentDidMount() {
    model.subscribe(this.subscription);
    this.whenScrollWindow();
    window.addEventListener('scroll', this.whenScrollWindow, { passive: true });
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    window.removeEventListener('scroll', this.whenScrollWindow);
  }

  whenScrollWindow = () => {
    let next = this.refPages.find(
      (item) => item.offsetTop > window.pageYOffset + item.offsetHeight / 1.5
    );
    if (
      window.innerHeight + Math.round(window.pageYOffset) >=
      this.refContainer?.offsetHeight - 100
    ) {
      next = null;
    }
    this.setState({ position: window.pageYOffset, next });
  };

  scroll = () => {
    if (!this.state.next)
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    else
      this.state.next.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
  };

  isRotate = () => {
    return this.props.screenDetail.isSmallScreen;
  };

  renderOption = (signupUrl, imgSrc, label) => {
    const active = model.state.signupUrl === signupUrl;
    const rotateOption = this.isRotate() ? 0.7 : 1;
    return (
      <div className={'mc-flex-20-col mc-flex-center'}>
        <MCButton
          circle
          outline
          primary={active}
          light={active}
          blacklight={!active}
          style={{
            padding: remCss(50 * rotateOption),
            position: 'relative'
          }}
          onClick={() => model.setState({ signupUrl })}
        >
          <img
            src={imgSrc}
            width={remCss(100 * rotateOption)}
            height={remCss(100 * rotateOption)}
          />
          {active && (
            <div
              style={{
                position: 'absolute',
                right: remCss(5 * rotateOption),
                top: remCss(5 * rotateOption)
              }}
            >
              <SVGIcon
                iconname={BASE_ICONS.CHECK}
                circle
                fill={scssVariables['colors-mc-primary']}
                dark
                width={50 * rotateOption}
                padding={5 * rotateOption}
              />
            </div>
          )}
        </MCButton>
        <div className={`mc-${active ? 'primary' : 'text'}-424 mc-text-center`}>
          {lang.t(label)}
        </div>
      </div>
    );
  };

  renderSelect = () => (
    <div
      className={`mc-flex-${this.isRotate() ? '25' : '40'}-col mc-m-auto ${this.isRotate() ? 'mc-pt30' : 'mc-p30 '}`}
    >
      <div className='mc-value-434 mc-text-center'>{lang.t('Join LifeApp')}</div>
      <div className={'mc-m-auto'}>{this.renderOption('/signup', BusinessWoman, 'As a User')}</div>
      <div className={`mc-flex-${this.isRotate() ? '25' : '40'}`}>
        {this.renderOption('/signup-doctor', Doctor, 'As a Doctor')}
        {this.renderOption('/signup-clinic', Hospital, 'As a Clinic')}
      </div>
      <div className={'mc-flex-25'}>
        <MCButton large quaternary light radius flex type={'link'} to={model.state.signupUrl}>
          {lang.t('Sign up')}
        </MCButton>
        <MCButton large primary light radius flex type={'link'} to={'/login'}>
          {lang.t('Login')}
        </MCButton>
      </div>
    </div>
  );

  render() {
    const featureFont = this.isRotate() ? 36 : 50;
    const features = [
      {
        img: require('src/assets/images/welcome/feature-1.png'),
        content: (
          <>
            <span className={`mc-primary-6${featureFont}`}>Mobile apps</span> for doctors and
            clients
          </>
        )
      },
      {
        img: require('src/assets/images/welcome/feature-2.png'),
        content: (
          <>
            <span className={`mc-primary-6${featureFont}`}>Telemedicine with</span> video calls and
            video messages
          </>
        )
      },
      {
        img: require('src/assets/images/welcome/feature-3.png'),
        content: (
          <>
            <span className={`mc-primary-6${featureFont}`}>Medical timeline</span> for each patient
          </>
        )
      },
      {
        img: require('src/assets/images/welcome/feature-4.png'),
        content: (
          <>
            Easy to share <span className={`mc-primary-6${featureFont}`}>medical journeys</span>{' '}
            with photos and videos
          </>
        )
      },
      {
        img: require('src/assets/images/welcome/feature-5.png'),
        content: (
          <>
            Get new clients through our{' '}
            <span className={`mc-primary-6${featureFont}`}>discovery mode</span>
          </>
        )
      },
      {
        img: require('src/assets/images/welcome/feature-6.png'),
        content: (
          <>
            Follow up with your <span className={`mc-primary-6${featureFont}`}>patients</span> and
            see their history
          </>
        )
      }
    ];
    return (
      <div
        ref={(ref) => (this.refContainer = ref)}
        className={'mc-container mc-welcome-user'}
        style={{ backgroundColor: 'white', height: 'auto', gap: 120 }}
      >
        <div
          className={'mc-container-content'}
          style={
            this.isRotate()
              ? {
                  paddingBottom: remCss(20),
                  paddingTop: remCss(80),
                  paddingLeft: remCss(20),
                  paddingRight: remCss(20)
                }
              : {
                  paddingBottom: remCss(30),
                  paddingTop: remCss(30),
                  paddingLeft: remCss(60),
                  paddingRight: remCss(60)
                }
          }
        >
          <div className={'mc-flex mc-wrap mc-flex-start'}>
            <Link
              className={'mc-page-auth-logo mc-pointer'}
              to={'/'}
              style={{ zIndex: 2, padding: remCss(this.isRotate() ? 20 : 30) }}
            >
              <Logo screenDetail={this.props.screenDetail} />
            </Link>
            <div className={'mc-page-auth-image-right'}>
              <SVGIcon iconname={GENERAL_ICONS.LOGO_RIGHT} />
            </div>
          </div>
          <div
            style={{
              marginLeft: 'auto',
              marginRight: remCss(60),
              zIndex: 3,
              ...(this.isRotate() ? { position: 'absolute', right: -30, top: 32 } : {})
            }}
          >
            <LangSelect width={remCss(200)} />
          </div>
          <div
            className={'mc-container-content__body-gap horizontal mc-wrap'}
            style={{ gap: '6%', zIndex: 2 }}
          >
            <div className={'mc-flex-25-col mc-flex-center'} style={{ maxWidth: remCss(850) }}>
              <div className={'mc-grow'} />
              <img src={HomeImg} alt={''} style={{ width: '92%' }} />
              <div className={`mc-primary-9${this.isRotate() ? '30' : '42'} mc-text-center`}>
                {lang.t('The absolute best telemedicine app to date!')}{' '}
              </div>
            </div>
            <div
              className={'mc-container-content__body-gap-center'}
              style={{ flex: 0 }}
              ref={(ref) => (this.refPages[0] = ref)}
            >
              <div className={'mc-page-auth-wrap'} style={{ justifyContent: 'flex-start' }}>
                {this.renderSelect()}
              </div>
            </div>
          </div>
        </div>
        <div
          className={'mc-container-content mc-flex-50-col'}
          style={{
            padding: 0,
            overflow: 'hidden',
            marginLeft: this.isRotate() ? remCss(15) : '7%',
            marginRight: this.isRotate() ? remCss(15) : '7%'
          }}
        >
          {features.map((feature, index) => (
            <div key={index} ref={(ref) => (this.refPages[index + 1] = ref)}>
              {index === 0 && (
                <div className={'mc-text-center mc-plr50 mc-pb50 mc-mb50'}>
                  <span className={'mc-value-958'}>Our </span>
                  <span className={'mc-primary-958'}>Features</span>
                </div>
              )}
              <div
                className={'mc-flex-25 mc-wrap'}
                style={{ flexDirection: index % 2 === 1 ? 'row-reverse' : 'row' }}
              >
                <div className={'mc-grow'} style={{ minWidth: '57%' }}>
                  <img
                    src={feature.img}
                    style={{
                      width: '100%',
                      minWidth: remCss(550 * (this.isRotate() ? 0.5 : 1)),
                      maxWidth: remCss(960),
                      maxHeight: '90vh',
                      objectFit: 'contain'
                    }}
                  />
                </div>
                <div
                  className={'mc-flex-30 mc-flex-start mc-grow'}
                  style={{ width: '100%', minWidth: remCss(300) }}
                >
                  <div>
                    <SVGIcon
                      circle
                      dark
                      padding={5}
                      iconname={BASE_ICONS.CHECK}
                      width={this.isRotate() ? 40 : 50}
                      fill={scssVariables['colors-mc-primary']}
                    />
                  </div>
                  <div className={`mc-value-6${featureFont}`}>{feature.content}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div
          className={'mc-container-content mc-flex-50-col'}
          style={{ padding: 0 }}
          ref={(ref) => (this.refPages[features.length + 1] = ref)}
        >
          <div className={'mc-text-center mc-plr50'}>
            <span className={'mc-value-650'}>Furthermore, LifeApp is the </span>
            <span className={'mc-primary-650'}> Mobile-first design</span>
          </div>
          <img
            src={MultipleImg}
            style={{
              width: '100%',
              minWidth: remCss(550 * (this.isRotate() ? 0.5 : 1)),
              maxHeight: '90vh',
              objectFit: 'contain'
            }}
          />
        </div>

        <div className={'mc-container-content mc-flex-50-col '} style={{ padding: 0 }}>
          <div className={'mc-text-center mc-plr50'}>
            <span className={'mc-value-650'}>Download</span>
            <span className={'mc-primary-650'}> mobile </span>
            <span className={'mc-value-650'}>app</span>
          </div>
          <div className={'mc-flex-20 '} style={{ justifyContent: 'center' }}>
            <a
              className={'mc-no-style-btn'}
              href={'https://play.google.com/apps/test/ai.lifeapp/9'}
            >
              <img width={remCss(300 * (this.isRotate() ? 0.5 : 1))} src={GooglePlayImg} />
            </a>
            <a className={'mc-no-style-btn'} href={'https://apps.apple.com/'}>
              <img width={remCss(300 * (this.isRotate() ? 0.5 : 1))} src={AppleImg} />
            </a>
          </div>
        </div>

        <div
          className={`mc-flex-col mc-flex-center`}
          style={{ position: 'sticky', bottom: 20, zIndex: 2, height: 0 }}
        >
          {this.state.next ? (
            <button className={'mc-scroll-down'} onClick={this.scroll}>
              <SVGIcon iconname={GENERAL_ICONS.ARROW_DOWN} width={35} />
              <span className={'mc-label-520'}>{lang.t('Scroll down')}</span>
            </button>
          ) : (
            <button className={'mc-scroll-down'} onClick={this.scroll}>
              <span className={'mc-rotate mc-rotate-180'}>
                <SVGIcon iconname={GENERAL_ICONS.ARROW_DOWN} width={35} />
              </span>
              <span className={'mc-label-520'}>{lang.t('Scroll top')}</span>
            </button>
          )}
        </div>
        <div ref={(ref) => (this.refPages[features.length + 2] = ref)}>
          <FooterInfo isRotate={this.isRotate()} />
        </div>
      </div>
    );
  }
}

export default withRouter(WelcomeUser);
